// extracted by mini-css-extract-plugin
export default {"star":"styles__star___JWM5t","selected":"styles__selected___nPeaf styles__star___JWM5t","name":"styles__name___H44Q9"};